import React from "react";

export const DropdownInput = ({
  increment,
  decrement,
  handleChange,
  qty = "00",
  value,
  incrementMainclass,
  incrementSubClass,
  inputCardClass
}) => {
  return (
    <div className={ incrementMainclass }>
      <img
        src={`${process.env.PUBLIC_URL}` + "/media/icons/minus-icon.svg"}
        className={`cursor-pointer ${incrementSubClass}`}
        onClick={decrement}
      />
      <input
        type="number"
        min={0}
        className={inputCardClass}
        value={value}
        defaultValue={qty}
        onChange={handleChange}
        placeholder="00"
      />
      <img
        src={`${process.env.PUBLIC_URL}` + "/media/icons/plus-icon.svg"}
        className={`cursor-pointer ${incrementSubClass}`}
        onClick={increment}
      />
    </div>
  );
};
